import React, { ReactElement } from 'react'

export const EscapedIcon = (): ReactElement => (
    <svg viewBox='0 0 100 100'>
        <path d='m50 5v11.25c18.609 0 33.75 15.141 33.75 33.75s-15.141 33.75-33.75 33.75-33.75-15.141-33.75-33.75h-11.25c0 24.852 20.148 45 45 45s45-20.148 45-45-20.148-45-45-45z' />
        <path d='m50 57.953 7.9531-7.9531-32.102-32.102 12.898-12.898h-33.75v33.75l12.898-12.898z' />
    </svg>
)
